import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  keyLabel: {
    whiteSpace: "nowrap",
  },
  codeCompact: {
    wordBreak: "break-word",
  },

  code: {
    height: 2 * theme.spacing.lg,
    lineHeight: `${2 * theme.spacing.lg}px`,
    maxWidth: "100%",
    overflowX: "auto",
    overflowY: "hidden",
    paddingBottom: 0,
    paddingTop: 0,
    width: "100%",
  },

  copy: {
    flex: "1 0 auto",

    [`@media (min-width: ${theme.breakpoints.md}px)`]: {
      flex: "0 0 auto",
    },
  },
}));
